module.exports = __webpack_public_path__ + "img/result_txt_i.b024c56b.png";